import React from "react";
import { useSelector } from "react-redux";
import { faCheck, faPlusCircle, faTrashAlt } from "@fortawesome/pro-solid-svg-icons";

import Button from "@/components/button";
import { useModal } from "@/hooks/use-modal";
import * as animationActions from "@/lib/state/actions/animation-actions";
import { animationSelector } from "@/lib/state/selectors/animation-selector";
import { useAppDispatch } from "@/lib/state/store";

import { ButtonBar, Module } from "../../layouts";
import { ButtonGroup } from "../../layouts/button-group";

import ModalTitle from "./modal-title";

const EditLayersModal = () => {
  const dispatch = useAppDispatch();
  const animationState = useSelector(animationSelector);
  const { closeModal } = useModal();

  const formattedLayers = animationState.layers
    .map((name, index) => ({
      index,
      name,
    }))
    .reverse();

  return (
    <div>
      <ModalTitle>Edit Layers</ModalTitle>
      <Module>
        {animationState.layers.length < 5 && (
          <Button
            icon={faPlusCircle}
            onClick={() => dispatch(animationActions.addLayer())}
            type="neutral"
          >
            Add layer
          </Button>
        )}
        <ol>
          {formattedLayers.map((layer, index) => {
            return (
              <li key={index} className="p-1">
                <strong>{layer.index + 1}:</strong>{" "}
                <input
                  className="text-sm rounded-md w-40 shadow-inner p-1 border border-gray-400 mr-2"
                  type="text"
                  maxLength={10}
                  value={layer.name}
                  onChange={(e) => {
                    dispatch(
                      animationActions.renameLayer({
                        index: layer.index,
                        name: e.target.value,
                      }),
                    );
                  }}
                />
                {layer.index > 0 && (
                  <Button
                    icon={faTrashAlt}
                    onClick={() =>
                      dispatch(
                        animationActions.deleteLayer({ index: layer.index }),
                      )
                    }
                    type="negative"
                  >
                    Delete
                  </Button>
                )}
              </li>
            );
          })}
        </ol>
      </Module>
      <ButtonBar>
        <ButtonGroup align="right">
          <Button icon={faCheck} onClick={closeModal} type="positive">
            Done
          </Button>
        </ButtonGroup>
      </ButtonBar>
    </div>
  );
};

export default EditLayersModal;
